import { FC, useMemo, useState } from 'react';

import styled from '@emotion/styled';
import { Exam } from 'store/my-registrations/types';

import { Button, Icon, IcoPencil } from '@britishcouncil/react-solas';
import { Card } from '@britishcouncil/react-solas-ors3';

import { ChildProtectionModal } from './ChildProtectionModal';
import { ExamItem } from './ExamItem';
import { OnlinePaymentDiscountAdvertMsg } from 'components/OnlinePaymentDiscountAdvertMsg';

export type ExamsGroupProps = {
  registrationGroupReference: string;
  registrationGroupId: number;
  paymentSlipNumber: string | null;
  isChild: boolean;
  candidateName: string;
  exams: Exam[];
  countryId: number;
  paid: boolean;
};

export const ExamsGroup: FC<ExamsGroupProps> = ({ paid, countryId, ...group }) => {
  const [showChildProtectionModal, setChildProtectionModal] = useState(false);
  const canEditChildProtection = useMemo(
    () =>
      group.exams.reduce(
        (value, item) => value && item.isCurrentSession && !item.registrationExported && !item.isCanceled,
        true,
      ),
    [group.exams],
  );

  const showOnlinePaymentAdvert = !paid && group.exams.some((exam) => exam.onlinePaymentFee < exam.fee && exam.fee > 0);

  return (
    <Card>
      <CandidateDetails>
        {group.isChild && (
          <Button
            size="xs"
            onClick={() => {
              setChildProtectionModal(true);
            }}
          >
            <Icon>
              <IcoPencil />
            </Icon>
            Child protection
          </Button>
        )}
        <p>
          Candidate: {group.candidateName} {group.isChild && '(minor)'}
        </p>
        <p>Reference number: {group.paymentSlipNumber ?? group.registrationGroupReference}</p>

        {showOnlinePaymentAdvert && <OnlinePaymentDiscountAdvertMsg countryId={countryId} />}
      </CandidateDetails>

      {group.exams.map((exam, i) => (
        <ExamItem exam={exam} key={i} />
      ))}

      {showChildProtectionModal && (
        <ChildProtectionModal
          registrationGroupId={group.registrationGroupId}
          readonly={!canEditChildProtection}
          onExit={() => setChildProtectionModal(false)}
        />
      )}
    </Card>
  );
};

const CandidateDetails = styled.div`
  text-align: right;
  p {
    text-align: left;
    margin: 0;
    font-weight: bold;
  }
  button {
    margin-bottom: 10px;
  }
`;
